import { createContext, useContext, useState } from "react";

const ViolationContext = createContext(null);

export function ViolationProvider({ children, onAutoSubmit }) {
  const [violations, setViolations] = useState(0);

  const addViolation = (reason) => {
    console.warn("Violation:", reason);
    setViolations((v) => {
      const next = v + 1;
      if (next >= 3 && onAutoSubmit) {
        onAutoSubmit();
      }
      return next;
    });
  };

  return (
    <ViolationContext.Provider value={{ violations, addViolation }}>
      {children}
    </ViolationContext.Provider>
  );
}

export function useViolation() {
  return useContext(ViolationContext);
}
